var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-1m9xqx9",
    "aria-label": "trash",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5429 21.0041H8.45709C7.2809 21.0041 6.303 20.0986 6.21279 18.9258L5.24719 6.37305H18.7528L17.7872 18.9258C17.697 20.0986 16.7191 21.0041 15.5429 21.0041V21.0041Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0033 6.37326H3.99667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18633 2.99609H14.8137C15.4353 2.99609 15.9391 3.49998 15.9391 4.12156V6.3725H8.06086V4.12156C8.06086 3.49998 8.56475 2.99609 9.18633 2.99609Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9696 10.875V16.5023 M10.0304 10.875V16.5023"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.d17ac415f92e5a0e3acdd3660dbe91b0.svg";
export { ForwardRef as ReactComponent };